import { formatCents, humanize } from '@ea/shared';

export { formatCents, humanize };

const TZ = 'America/New_York';

export function formatDateTime(v: string | Date | null | undefined): string {
  if (!v) return '—';
  return new Intl.DateTimeFormat('en-US', { timeZone: TZ, month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' }).format(new Date(v));
}

export function formatDate(v: string | Date | null | undefined): string {
  if (!v) return '—';
  // Date-only strings (YYYY-MM-DD) are calendar dates, not instants.
  if (typeof v === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(v)) {
    const [y, m, d] = v.split('-').map(Number);
    return new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }).format(Date.UTC(y, m - 1, d));
  }
  return new Intl.DateTimeFormat('en-US', { timeZone: TZ, month: 'short', day: 'numeric', year: 'numeric' }).format(new Date(v));
}

export function relativeTime(v: string | Date | null | undefined): string {
  if (!v) return '—';
  const diff = new Date(v).getTime() - Date.now();
  const abs = Math.abs(diff);
  const rtf = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });
  if (abs < 60_000) return rtf.format(Math.round(diff / 1000), 'second');
  if (abs < 3_600_000) return rtf.format(Math.round(diff / 60_000), 'minute');
  if (abs < 86_400_000) return rtf.format(Math.round(diff / 3_600_000), 'hour');
  return rtf.format(Math.round(diff / 86_400_000), 'day');
}

export const ref = (prefix: string, n: number | null | undefined) => (n == null ? '—' : `${prefix}-${String(n).padStart(6, '0')}`);

export const toDateInput = (v: string | Date | null | undefined) => (v ? new Date(v).toISOString().slice(0, 10) : '');

/** Local datetime-local input value in the user's browser timezone. */
export function toDateTimeInput(v: string | Date | null | undefined) {
  if (!v) return '';
  const d = new Date(v);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export const fromDateTimeInput = (v: string) => (v ? new Date(v).toISOString() : null);

export const dollarsToCents = (v: string) => Math.round(Number(v || 0) * 100);
export const centsToDollars = (c: number | null | undefined) => ((c ?? 0) / 100).toFixed(2);
